/**
 * <OrderOverview
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router'
import classnames from 'classnames'
import './OrderOverview.scss';
import moment from 'moment';
import posterOrderPay from 'controllers/payment/posterOrderPay';
import weChatPosterPaymentModal from 'template/Modals/weChatPosterPayment'
import aliPosterPaymentModal from 'template/Modals/aliPosterPayment'
import RegisterClassModal from 'shared/RegisterClassModal';
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';

const locale = {
  id: 'OrderOverview',
  code: 'CN',
  text: {
    "Registration Successful": "报名成功",
    "You will need to pay the registration fee at the school after register online. Please contact school for more information.": "此海报报名为线上注册，线下缴费，请联系校方缴费。",
    "After you pay your registration fee online, it means you have successfully registered.": "此海报报名为线上缴费，缴费成功后即报名成功。",
    "If you had any questions, please contact us.": "如果对报名有任何问题，也请尽快联系我们",
    "DOB": "生日",
    "Name": "名称",
    "Email": "邮件",
    "Mobile Number": "手机",
    'Attendee Info':'报名人资料',
    "Contact Info": "联系人资料",
    'Order Summary': '订单详情',
    'Order Price': '订单价格',
    'Total Price: ${price}': '总价：${price}',
    'Payment Method': '付款方式',
    'WeChat Pay': '微信支付',
    'Alipay': '支付宝支付',
    'Pay': '付款',
    'Edit': '编辑',
    'Payment Successful!': '付款成功！',
    'This school has not integrate weChat Pay and AliPay, please contact our product specialist': '此学校未开通微信支付和支付宝支付，请联系我们的产品专家',
    'Unexpected error, please try again': '提交之后未能成功，可能由于信息错误引起，请再试一次',
    'Please make sure to have Aplipay App to continue payment': '请确认已有支付宝APP，才可使用支付宝支付',
    'Unable to use Alipay within WeChat, please use a broswer': '无法在微信上使用支付宝支付，请使用浏览器',
    'For WeChat Pay option, please use a PC browser': '请使用电脑桌面端浏览器进行微信支付',
    '': '',
  }
}

class OrderOverview extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    let {price_type} = props.orderInfo
    const PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount']

    this.state = {
      schoolInfo: {},
      paymentType: PRICE_TYPE[price_type],
      priceList: [],
      paymentMethod: 'weChatPay',
      paySuccessful: false,
    }

    this.renderAttendee = this.renderAttendee.bind(this);
    this.onChange = this.onChange.bind(this);
    this.startPaymentProcess = this.startPaymentProcess.bind(this);
  }

  componentWillMount() {
    let browser_type;
    let mobile = false;
    if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)){
      mobile = true
    }
    // window.innerWidth <= 800 && window.innerHeight <= 650

    if(/micromessenger/i.test(navigator.userAgent)){
      browser_type = 'weChatBrowser'
    } else if(mobile){
      browser_type = 'mobileBroswer'
    } else {
      browser_type = 'pcBrowser'
    }

    this.setState({
      browser_type,
    })
  }

  renderAttendee() {
    const {orderInfo} = this.props;

    return orderInfo.order.attendee.map((item, key)=>{
      const {
        first_name,
        last_name,
        email,
        phone,
        date_of_birth,
      } = item;

      let DOBstr = "";
      if (date_of_birth) {
        DOBstr = moment(date_of_birth, 'YYYY-MM-DD').format('MMMM DD, YYYY');
      }

      return (
        <div className='attendee-info' key={key}>
          <div className='row'>
            <div className='col-sm-6'>
              <label>{__('Name', locale)}</label>
              <p>{first_name} {last_name}</p>
            </div>
            <div className='col-sm-6'>
              <label>{__('DOB', locale)}</label>
              <p>{DOBstr}</p>
            </div>
          </div>
          <div>
            <label>{__('Email', locale)}</label>
            <p>{email}</p>
          </div>
          <div>
            <label>{__('Mobile Number', locale)}</label>
            <p>{phone}</p>
          </div>
        </div>
      );
    });
  }

  getTicketPurchaseList() {
    const { ticketInfo, order } = this.props.orderInfo;
    const {ticket} = order

    if (!Array.isArray(ticket)) {
      return [];
    }

    return ticket.map(({ amount, price }, index)=>{
      return {
        ...ticketInfo[index],
        amount,
        price,
      }
    });

  }

  onChange(e){
    this.setState({paymentMethod: e.target.value})
  }

  startPaymentProcess(){
    let {paymentMethod, browser_type} = this.state
    const {order_number} = this.props

    posterOrderPay(order_number, {payment_method: paymentMethod, browser_type: browser_type})
    .then((res) => {
      if(res.result == 'submit successfully'){
        if(paymentMethod == 'weChatPay'){

          weChatPosterPaymentModal({url: res.payment_returned_url, order_number: order_number, type: 'wechatpay', browser_type: browser_type})
          .then((res) => {
            this.setState({paySuccessful: true})
          })

        } else if (paymentMethod == 'alipay'){
          window.open(res.payment_returned_url)
          aliPosterPaymentModal({url: res.payment_returned_url, order_number: order_number, type: 'alipay'})
          .then((res) => {
            this.setState({paySuccessful: true})
          })
        }
      } else if(res.result == 'failure'){
        // failure reason
        if(res.reason == 'payment_method is not supported with this browser_type.'){

        } else if(res.reason == 'please open it again with mobile browser.'){

        } else if(res.reason == 'this order can not be paid.'){

        } else if(res.reason == 'this order can not be paid by Wechat/Alipay.'){
          alert.warning(__('This school has not integrate weChat Pay and AliPay, please contact our product specialist', locale))
        } else if(res.reason == 'please confirm info and submit again'){
          alert.warning(__('Unexpected error, please try again', locale))
        }
      }
    })
  }

  orderSummary(){
    const ticketPurchaseList = this.getTicketPurchaseList()

    return(
      <div>
        <h3>{__('Order Price', locale)}</h3>
        {ticketPurchaseList.map((tix, i) => {
          this.priceList = [];
          this.priceList.push(tix.amount * tix.price)
          return(
            <div key={i}>
              <div className='tix-title'>
                <span>{tix.title}</span>
                <span className='pull-right'>{tix.amount + ' x $' + tix.price}</span>
              </div>
            </div>
          )
        })}
        <span className='tix-total-price pull-right'>{__('Total Price: ${price}', locale, {price: this.priceList})}</span>
      </div>
    )
  }

  renderPayButton(){
    const {paymentType, paymentMethod, browser_type} = this.state
    const {order_number} = this.props;
    
    let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))

    if( (browser_type == 'pcBrowser' && isSafari && paymentMethod == 'alipay') || (browser_type == 'mobileBroswer' && paymentMethod == 'alipay') ){
      return(
        <div style={{display: 'block'}}>
          {browser_type == 'mobileBroswer' && <span>{__('Please make sure to have Aplipay App to continue payment', locale)}</span>}
          <a className='btn btn-primary btn-block' target='_blank' onClick={() => {
            aliPosterPaymentModal({order_number: order_number, type: 'alipay'})
            .then((res) => {
              this.setState({paySuccessful: true})
            })
          }} href={`/alipay-redirect?order_number=${order_number}&payment_method=${paymentMethod}&browser_type=${browser_type}`}>{__('Pay', locale)}</a>
        </div>
      )
    } else {
      return (
        <div>
          {browser_type == 'weChatBrowserBroswer' && <span>{__('Unable to use Alipay within WeChat, please use a broswer', locale)}</span>}
          <button className='btn btn-primary btn-block' onClick={this.startPaymentProcess}>{__('Pay', locale)}</button>
        </div>
      )
    }
  }

  render() {
    const {orderInfo, poster_info, posterDetail, order_number} = this.props;

    const {recipient, ticketInfo, ticket} = orderInfo.order;
    const {
      title,
      school_logo,
      school_name,
      school_address,
      school_city,
      school_province,
      school_postal_code,
      school_email,
      school_phone,
      school_suite_num,
      school_website,
      school,
    } = poster_info;

    const {
      paymentType,
      priceList,
      paymentMethod,
      paySuccessful,
      paymentUrl,
      browser_type,
    } = this.state

    const ticketPurchaseList = this.getTicketPurchaseList()

    return (
      <div className='poster-order-overview'>
        <div className='container'>
          <h1>{ paymentType == 'freeOrPayOffline' ? __("Registration Successful", locale) : __('Order Summary', locale)}</h1>
          <h4>{ paymentType== 'freeOrPayOffline' ? __("You will need to pay the registration fee at the school after register online. Please contact school for more information.", locale) : __('After you pay your registration fee online, it means you have successfully registered.', locale)}</h4>
          <div className='order-content'>
            <div className='col-sm-12'>
              <div>
                <h2>
                  {title}
                  {paymentType != 'freeOrPayOffline' && <span className='tix-edit pull-right' onClick={() => {
                    RegisterClassModal({posterDetail, schoolId: school, orderInfo: orderInfo})
                  }}>{__('Edit', locale)}</span>}
                </h2>
              </div>
              <div className='row col-sm-12'>
                <div>
                <h3>{__('Attendee Info', locale)}</h3>
                  {this.renderAttendee()}
                  <div className='recipient-info'>
                    <h3>{__('Contact Info', locale)}</h3>
                    <div className='row col-sm-12'>
                      <div>
                        <label>{__('Name', locale)}</label>
                        <p>{recipient.full_name}</p>
                      </div>
                      <div>
                        <label>{__('Email', locale)}</label>
                        <p>{recipient.email}</p>
                      </div>
                      <div>
                        <label>{__('Mobile Number', locale)}</label>
                        <p>{recipient.phone}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {paymentType== 'freeOrPayOffline' && <div className='col-sm-6 pull-right'>
              <div className='school-info'>
                <h3>{__('If you had any questions, please contact us.', locale)}</h3>
                <h5>{school_name}</h5>
                <p>{school_address} {school_suite_num} {school_city} {school_province} {school_postal_code}</p>
                <p>{school_website}</p>
                <p>{school_email}</p>
                <p>{school_phone}</p>
              </div>
            </div>}
            {paymentType != 'freeOrPayOffline' && paySuccessful == false &&
              <div className='col-sm-5'>
                {this.orderSummary()}
                <div className='school-info'>
                  <h3>{__('Payment Method', locale)}</h3>
                  <div className='radio'>
                    {browser_type == 'pcBrowser' && <label className='wechat-pay'>
                      <input
                        type='radio'
                        value='weChatPay'
                        name='optradio'
                        checked={paymentMethod == 'weChatPay'}
                        onChange={this.onChange}
                      />
                      <span>{__('WeChat Pay', locale)}</span>
                    </label>}
                    <label className='alipay'>
                      <input type='radio' value='alipay' name='optradio' onChange={this.onChange} disabled={browser_type == 'weChatBrowser'} />
                      <span>{__('Alipay', locale)}</span>
                    </label>
                    {browser_type != 'pcBrowser' && <p>{__('For WeChat Pay option, please use a PC browser', locale)}</p>}
                  </div>

                  {this.renderPayButton()}

                </div>
              </div>
            }
            {paySuccessful == true &&
              <div className='col-sm-5'>
                <div className='school-info'>
                  {this.orderSummary()}
                  <h3>{__('Payment Successful!', locale)}</h3>
                </div>
              </div>
            }

          </div>
        </div>
      </div>
    )
  }
}

export default OrderOverview;



// WEBPACK FOOTER //
// ./src/shared/PosterView/OrderOverview.js